import {
  TWO_PI,
  PHI,
  SR,
  SGR,
  GA,
  EUL,
  RFC,
  FC,
} from "./local_mods/math_constants.js";
import {
  frand_rng,
  arr_pick,
  fib_num,
  fx_shuffle_arr,
  calculateAspectRatioFit,
} from "./local_mods/util.js";

const init_scene = function () {
  // let base_OPR = arr_pick([SR, PHI, SGR, GA, EUL]);
  let base_OPR = arr_pick([GA, EUL]);
  //   const bkg_clr = 255;
  const OPR = base_OPR.nat;
  const i_OPR = base_OPR.inv;
  // const OPR_abbrv = base_OPR.abbrv;

  //   https://www.fxhash.xyz/generative/25124
  let explicitPixelWidth = -1;
  let explicitPixelHeight = -1;

  const URLParams = Object.fromEntries(
    new URLSearchParams(window.location.search)
  );
  try {
    if (URLParams["width"] && URLParams["height"]) {
      explicitPixelWidth = parseInt(URLParams.width);
      explicitPixelHeight = parseInt(URLParams.height);
    }
  } catch (e) {
    console.warn(e);
  }
  const window_dims = {
    w:
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth,
    h:
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight,
  };
  // let min_dim = Math.min(window_dims.w, window_dims.h);
  let max_dim = Math.max(window_dims.w, window_dims.h);
  let min_dim = Math.min(window.innerWidth, window.innerHeight);

  //   const all_palettes = [colour_palettes];

  let state = 1;

  return {
    base_OPR,
    OPR,
    i_OPR,
    window_dims,
    fxhash,

    min_dim,
    max_dim,
  };
};

export { init_scene };
